import * as createBlockUtils from '../../../utils/create-block';
import { ResolveFields } from '../../../utils/create-block';
import * as expressionUtils from '../../../utils/surveys/expressions';
import * as fieldUtils from '../../../utils/surveys/fields';

import { MeasureBreakdownProps, MeasuresBreakdownBlock } from './measure-breakdown';

const resolveFields: ResolveFields<MeasureBreakdownProps> = ({ props: { survey } }, { fields }) => ({
  ...fields,
  ...(survey && {
    selectedExpressionName: fieldUtils.createExpressionField(survey, expressionUtils.ExpressionTypes.MEASURE),
    answerBreakdown: {
      type: 'array',
      label: 'Answer Breakdown',
      arrayFields: {
        questionName: fieldUtils.createQuestionField(survey),
      },
    },
  }),
  allRespondents: {
    type: 'radio',
    options: [
      { label: 'On', value: true },
      { label: 'Off', value: false },
    ],
  },
  answerBreakdownKey: {
    type: 'text',
    label: 'Answer Breakdown Key',
  },
  description: {
    type: 'text',
    label: 'Description',
  },
  hideMainMeasure: {
    type: 'radio',
    label: 'Hide Main Measure',
    options: [
      { label: 'False', value: false },
      { label: 'True', value: true },
    ],
  },
  title: {
    type: 'text',
    label: 'Title',
  },
});

const createMeasureBreakdownBlock = createBlockUtils.makeBlockFactory<MeasureBreakdownProps>(
  { withExampleAnswersJson: true },
  {
    fields: {
      additionalContent: {
        type: 'slot',
      },
    },
    label: 'Measures Breakdown',
    render: MeasuresBreakdownBlock,
    resolveFields,
  }
);

export { createMeasureBreakdownBlock, MeasuresBreakdownBlock, resolveFields };
